module.exports = __webpack_public_path__ + "img/遠傳電信.50fe2257.png";